import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { T } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Auth() {
  const { login, register, lang } = useAuth();
  const t = T[lang];
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      if (mode === "login") await login(email, password);
      else await register(name, email, password);
      toast.success(mode === "login" ? "Giriş başarılı" : "Kayıt başarılı");
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="max-w-md mx-auto px-4 py-14">
        <div className="bg-white rounded-2xl shadow-xl border border-[#e2e8f0] p-8 fade-in">
          <img src="/brand/logo.png" alt="logo" className="h-14 w-14 object-contain mx-auto mb-4" />
          <h1 className="font-display font-bold text-2xl text-[#1a2e4a] text-center">
            {mode === "login" ? t.loginTitle : t.registerTitle}
          </h1>

          <form onSubmit={submit} className="mt-6 space-y-4">
            {mode === "register" && (
              <div>
                <Label className="text-[#1a2e4a]">{t.name}</Label>
                <Input data-testid="auth-name-input" value={name} onChange={(e) => setName(e.target.value)} required className="mt-1" />
              </div>
            )}
            <div>
              <Label className="text-[#1a2e4a]">{t.email}</Label>
              <Input data-testid="auth-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1" />
            </div>
            <div>
              <Label className="text-[#1a2e4a]">{t.password}</Label>
              <Input data-testid="auth-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1" />
            </div>

            {error && <div data-testid="auth-error" className="text-sm text-[#c0392b] bg-[#fadbd8] rounded-md px-3 py-2">{error}</div>}

            <Button data-testid="auth-submit-btn" type="submit" disabled={loading} className="w-full bg-[#c0392b] hover:bg-[#a93226] text-white h-11">
              {loading ? "..." : mode === "login" ? t.login : t.register}
            </Button>
          </form>

          <button
            data-testid="auth-toggle-mode"
            onClick={() => { setMode(mode === "login" ? "register" : "login"); setError(""); }}
            className="mt-5 text-sm text-[#1a2e4a] hover:text-[#c0392b] w-full text-center underline underline-offset-4"
          >
            {mode === "login" ? t.noAccount : t.haveAccount}
          </button>
        </div>
      </div>
    </div>
  );
}
